module.exports = __webpack_public_path__ + "img/logoLogin.4f015481.png";